import type { EventNotification } from '../event-notification.model';

/** Canonical mock {@link EventNotification}. */
export const MOCK_EVENT_NOTIFICATION: EventNotification = {
  id: 1,
  event_type: 'factory_published',
  created_at: '2026-04-01T10:00:00Z',
  payload: { factory_name: 'Gulf Precision Manufacturing' },
  read: false,
  target_type: 'Factory',
  target_id: 1,
};

/** Builds an {@link EventNotification} from {@link MOCK_EVENT_NOTIFICATION}. */
export function createMockEventNotification(
  overrides?: Partial<EventNotification>
): EventNotification {
  return { ...MOCK_EVENT_NOTIFICATION, ...overrides };
}

/** Builds a list of mock {@link EventNotification} entries. */
export function createMockEventNotificationList(
  count = 3,
  overrideAt?: (index: number) => Partial<EventNotification>
): EventNotification[] {
  const demoEventTypes: Partial<EventNotification>[] = [
    {
      event_type: 'factory_published',
      payload: { factory_name: 'Gulf Precision Manufacturing' },
      target_id: 1,
      target_type: 'Factory',
    },
    {
      event_type: 'factory_rejected',
      payload: { factory_name: 'Desert Steel Works' },
      read: false,
      target_id: 2,
      target_type: 'Factory',
    },
    {
      event_type: 'profile_viewed',
      payload: {
        factory_name: 'Gulf Precision Manufacturing',
        view_count: 12,
      },
      read: false,
    },
    {
      event_type: 'project_factory_added',
      payload: {
        factory_name: 'Al Noor Fabrication',
        project_name: 'Line expansion',
      },
      target_id: 1,
      target_type: 'Project',
    },
    {
      event_type: 'submit_for_approval_arrival',
      payload: { factory_name: 'Emirates CNC Hub' },
    },
  ];

  return Array.from({ length: count }, (_, i) =>
    createMockEventNotification({
      id: i + 1,
      read: i > 0,
      ...demoEventTypes[i % demoEventTypes.length],
      ...overrideAt?.(i),
    })
  );
}
